module.exports = __webpack_public_path__ + "img/edit-icon-blue.611c6d93.svg";